import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';
import { LuMap, LuShield, LuShieldCheck } from 'react-icons/lu';

export default function Hero({ trackEvent }) {
  const handleCTA = () => {
    // Tracking : clic sur CTA hero
    trackEvent('hero_cta_click', { cta_label: 'Réserver le transport', location: 'hero' });
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSecondary = () => {
    trackEvent('hero_secondary_click', { cta_label: 'Découvrir nos services', location: 'hero' });
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero" data-tracking-name="Hero">
      {/* Éléments décoratifs de fond */}
      <div className="hero-bg-orb hero-bg-orb--1" />
      <div className="hero-bg-orb hero-bg-orb--2" />
      <div className="hero-grain" />

      
      <img  className='vector-two' src={require('../../assets/penguin.png')} alt='Dog'/>

      <div className="hero-container">
        {/* Colonne gauche : texte */}
        <div className="hero-content">
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{letterSpacing: -0.2}}
          >
            <span className="badge-dot"  />
            Spécialiste Transport Animal depuis 2008
          </motion.div>

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            Le voyage serein de vos compagnons,
            <span className="hero-title-accent"> sans frontières.</span>
          </motion.h1>

          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
          >
            Experts en transport aérien d'animaux à l'international, nous prenons en charge
            chaque détail — santé, sécurité et confort — pour que vos animaux voyagent
            comme ils le méritent.
          </motion.p>

          <motion.div
            className="hero-actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.65 }}
          >
            <button className="btn-primary hero-btn-primary" onClick={handleCTA}>
              <span>Réserver le transport</span>
              <span className="btn-arrow">→</span>
            </button>
            <button className="btn-secondary" onClick={handleSecondary}>
              Découvrir nos services
            </button>
          </motion.div>

          {/* Stats
          <motion.div
            className="hero-stats"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            {[
              { value: '15 000+', label: 'Animaux transportés' },
              { value: '80+', label: 'Pays desservis' },
              { value: '100%', label: 'Certifié IATA' },
            ].map((stat) => (
              <div className="hero-stat" key={stat.label}>
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </motion.div> */}
        </div>

        {/* Colonne droite : visuel */}
        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.96, x: 40 }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="hero-image-wrapper">
            {/* Image principale (SVG illustratif premium) */}
            <div className="hero-image-card">
              {/*  */}
              <img alt='chien et maitre' src={require('../../assets/2150062415.jpg')} className='hero-svg' />
            </div>

            {/* Badge flottant
            <motion.div
              className="hero-badge-float"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 1 }}
            >
              <span className="float-icon"><LuShieldCheck color='white'/></span>
              <div>
                <span className="float-title" style={{color: 'white'}}>Certifié IATA</span>
                <span className="float-sub" style={{color: 'white'}}>Norme internationale</span>
              </div>
            </motion.div> */}

            <motion.div
              className="hero-badge-float hero-badge-float--2"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 1.2 }}
            >
              <span className="float-icon"><LuMap/></span>
              <div>
                <span className="float-title">80+ Pays</span>
                <span className="float-sub">Réseau mondial</span>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className="hero-scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
      >
        <span style={{color: 'white'}}>Défiler</span>
        <div className="scroll-line" />
      </motion.div>
    </section>
  );
}
